export default __webpack_public_path__ + "static/media/O-036.fdbbefbb.png";